<% if (validated_ehr_appointment_slot_id) { %>
  <div class="item-icon"></div>
<% } else { %>
  <div class="item-icon attention"></div>
<% } %>

<div class="item-attribute__name"><%= I18n.summary.appointment %></div>

<div class="item-attribute__content">
  <% var visit_type %>
  <% if (validated_appointment_slot && validated_ehr_appointment_slot_id) { %>
    <div class="appointment-slot-visit-type">
      <%- validated_appointment_slot.visit_type_name %>
    </div>
    <div class="appointment-slot-datestamp">
      <span class="date"><%= Sparkle.Utilities.appointmentDate(moment.parseZone(validated_appointment_slot.start_time), AppointmentBooking.config.slot_show_year, I18n.moment_date_format, I18n.moment_date_format_with_year) %></span>
      <span class="time"><%= moment.parseZone(validated_appointment_slot.start_time).format(I18n.moment_time_format) %></span>
    </div>
  <% } else if (visit_type = validated_visit_types.find(function(visit_type) { return visit_type.id == validated_visit_type_id })) { %>
    <div class="appointment-slot-visit-type">
      <%- visit_type.name %>
    </div>
  <% } else { %>
    <div class="appointment-slot-visit-type">
      <%- appointment_slot.visit_type_name %>
    </div>
  <% } %>
</div>

<% if (validated_visit_types.length) { %>
<div class="item-attribute__action">
  <a class="appointment-edit-link" data-appointment-booking-wizard-behaviour="edit-appointment-slot" tabindex="0"><%= I18n.summary.edit %></a>
</div>
<% } %>
